export default {"src":"/_next/static/media/murata.a1212f9c.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};